import { styled } from "@mui/material";
import React from "react";

interface ProductMenuItemProps {
  label: string;
  link: string;
  icon?: React.ReactNode;
  isActive?: boolean;
}

const ProductMenuItem: React.FC<ProductMenuItemProps> = ({
  label,
  link,
  icon,
  isActive = false,
}) => {
  const isActiveItem = isActive || window.location.href.includes(label.toLocaleLowerCase());
  return (
    <ProductItem
      className={`product-menu-item ${isActiveItem ? "active" : ""}`}
      href={link}
      target="_blank"
    >
      {icon}
      <ProductItemLabel>{label}</ProductItemLabel>
    </ProductItem>
  );
};

export default ProductMenuItem;
const ProductItem = styled("a")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.tokens.colors.gray[1],

  borderRadius: 0,
  width: "5.5rem",
  height: "5.5rem",
  color: theme.tokens.colors.gray[7],
  textDecoration: "none",
  "img,svg": {
    height: "30px",
  },
  "&.active": {
    backgroundColor: theme.tokens.colors.blue[4],
  },
}));
const ProductItemLabel = styled("span")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  fontSize: "10px",
  lineHeight: "14px",
  letterSpacing: "0%",
  textAlign: "center",
  marginTop: "5px",
}));
